import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { jwtDecode } from 'jwt-decode'
import Cookies from 'js-cookie'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: DecodedToken | null
  setTokens: (access: string, refresh: string) => void
  clearTokens: () => void
  updateUser: (user: Partial<DecodedToken>) => void
}

export interface DecodedToken {
  company_code: string
  email: string
  name: string
  role: string
  sub: string
  exp: number
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setTokens: (access, refresh) => {
        try {
          const decoded = jwtDecode<DecodedToken>(access)
          set({ accessToken: access, refreshToken: refresh, user: decoded })
        } catch (error) {
          console.error('JWT decode error:', error)
          set({ accessToken: access, refreshToken: refresh, user: null })
        }
      },
      clearTokens: () => {
        Cookies.remove('axp_access_token')
        Cookies.remove('axp_refresh_token')
        set({ accessToken: null, refreshToken: null, user: null })
      },
      updateUser: (user: Partial<DecodedToken>) =>
        set(state => ({
          user: state.user ? { ...state.user, ...user } : null,
        })),
    }),
    {
      name: 'auth-storage',
      // 성능 최적화 설정
      partialize: state => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
      onRehydrateStorage: () => state => {
        console.log('Rehydrating state:', state)
        if (state?.accessToken) {
          try {
            const decoded = jwtDecode<DecodedToken>(state.accessToken)
            console.log('Decoded token:', decoded)
            state.user = decoded
          } catch (error) {
            console.error('JWT decode error on rehydrate:', error)
            state.user = null
          }
        }
      },
    },
  ),
)
